import React, { useEffect, useState } from "react";
import { api } from "../../../services/api";
import { formatInTimeZone } from "date-fns-tz";
import "./cardaniversario.css";
import Foto from "../Foto";

const DEFAULT_USER =
  "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg";

const cacheKey = (chapa) => `foto_${String(chapa)}`;
const getCachedPhoto = (chapa) => localStorage.getItem(cacheKey(chapa));
const setCachedPhoto = (chapa, dataUrl) => {
  try {
    localStorage.setItem(cacheKey(chapa), dataUrl);
  } catch {}
};

async function refreshPhoto(chapa, onChange) {
  try {
    const res = await api.get(`/usuario/foto/${chapa}`);
    if (res?.data?.foto) {
      const newUrl = `data:image/jpeg;base64,${res.data.foto}`;
      const oldUrl = getCachedPhoto(chapa);
      if (newUrl !== oldUrl) {
        setCachedPhoto(chapa, newUrl);
        if (typeof onChange === "function") onChange(newUrl);
      }
    }
  } catch {}
}

function BirthdayCarousel() {
  const [aniversariantes, setAniversariantes] = useState([]);
  const [fotosMap, setFotosMap] = useState({});
  const [fotoSelecionada, setFotoSelecionada] = useState(null);
  const [chapaUsuarioLogado, setChapaUsuarioLogado] = useState(null);
  const [isPaused, setIsPaused] = useState(false);

  const getBaseList = () => {
    if (aniversariantes.length === 0) return [];
    if (aniversariantes.length >= 8) return aniversariantes;
    const factor = Math.ceil(10 / aniversariantes.length);
    let list = [];
    for (let i = 0; i < factor; i++) {
      list = [...list, ...aniversariantes];
    }
    return list;
  };

  useEffect(() => {
    setChapaUsuarioLogado(localStorage.getItem("chapa"));

    const loadAniversariantes = async () => {
      try {
        const res = await api.get("/usuario/aniversario");
        const data = res?.data || [];
        setAniversariantes(data);

        const initialFotos = {};
        data.forEach((a) => {
          const chapa = String(a.chapa);
          initialFotos[chapa] = getCachedPhoto(chapa) || DEFAULT_USER;
        });
        setFotosMap(initialFotos);

        data.forEach((a) => {
          const chapa = String(a.chapa);
          refreshPhoto(chapa, (newUrl) => {
            setFotosMap((prev) => ({ ...prev, [chapa]: newUrl }));
          });
        });
      } catch (e) {
        console.error("Erro ao carregar aniversariantes", e);
      }
    };

    loadAniversariantes();
  }, []);

  const openFoto = (fotoUrl, nome, loja) => {
    if (!fotoUrl || fotoUrl === DEFAULT_USER) return;
    setFotoSelecionada({ foto: fotoUrl, nome, loja });
  };

  if (aniversariantes.length === 0) return null;

  const baseList = getBaseList();

  const renderCardList = (list) => (
    <div className="aniversario-segment">
      {list.map((pessoa, idx) => {
        const chapa = String(pessoa.chapa);
        const isAnonimo = pessoa.exibir !== "S";
        const fotoUrl = isAnonimo
          ? DEFAULT_USER
          : fotosMap[chapa] || DEFAULT_USER;
        const isUserBirthday = chapa === chapaUsuarioLogado;

        return (
          <div
            key={idx}
            className={`aniversario-card text-center ${
              isUserBirthday ? "birthday-highlight" : ""
            }`}
          >
            <h6 className="mb-1">{pessoa.nomefilial || "Loja não informada"}</h6>

            <img
              src={fotoUrl}
              alt={isAnonimo ? "Anônimo" : pessoa.nome}
              className="aniversario-foto"
              onClick={() => openFoto(fotoUrl, pessoa.nome, pessoa.nomefilial)}
              style={{
                cursor: fotoUrl !== DEFAULT_USER ? "zoom-in" : "default",
              }}
            />

            <h5 className="mt-2">
              {isAnonimo ? "Preferiu o anonimato" : pessoa.nome}
            </h5>

            <div className="aniversario-rodape">
              <small>
                🎂{" "}
                {formatInTimeZone(
                  pessoa.dtnascimento?.substring(0, 23),
                  "America/Sao_Paulo",
                  "dd'/'MM'"
                )}
              </small>

              {isUserBirthday && (
                <div className="parabens-message">🎉 Parabéns! 🎉</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div
      className="aniversario-carrossel-wrapper"
      onTouchStart={() => setIsPaused(true)}
      onTouchEnd={() => setTimeout(() => setIsPaused(false), 2000)}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className={`aniversario-track-animated ${isPaused ? "paused" : ""}`}>
        {renderCardList(baseList)}
        {renderCardList(baseList)}
      </div>

      <Foto
        show={!!fotoSelecionada}
        onClose={() => setFotoSelecionada(null)}
        foto={fotoSelecionada?.foto}
        nome={fotoSelecionada?.nome}
        info01={fotoSelecionada?.loja}
        info02=""
      />
    </div>
  );
}

export default BirthdayCarousel;